var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-menu', {
    attrs: {
      "max-width": "275",
      "offset-y": "",
      "origin": "center center",
      "transition": "scale-transition"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-btn', _vm._g({
          attrs: {
            "icon": ""
          }
        }, on), [_c('v-icon', [_vm._v("mdi-dots-vertical")])], 1)];
      }
    }]),
    model: {
      value: _vm.actionsMenu,
      callback: function ($$v) {
        _vm.actionsMenu = $$v;
      },
      expression: "actionsMenu"
    }
  }, [_c('v-card', [_c('v-list', {
    attrs: {
      "dense": "",
      "width": "224"
    }
  }, [_c('PermissionsDialog', {
    attrs: {
      "workspace": _vm.workspace
    }
  }), _c('v-list-item', {
    attrs: {
      "to": {
        name: 'aqlWizard'
      }
    }
  }, [_c('v-list-item-icon', {
    staticClass: "mr-3"
  }, [_c('v-icon', [_vm._v("mdi-magnify")])], 1), _c('v-list-item-content', [_vm._v(" AQL Wizard ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }